// extracted by css-extract-rspack-plugin
module.exports =  {"root":"cb643dc1fa","inputHint":"d0453bb984"};